import $ from 'jquery';

class SteppedCta {
    constructor () {
        this.$button = $('.js-stepped-button');

        this.$button.on('click', $.proxy(this.buttonClick, this)).attr('aria-expanded', 'false');
    }

    buttonClick (e) {
        e.preventDefault();
        const $elem = $(e.currentTarget);

        $elem.toggleClass('is-clicked');

        if ($elem.hasClass('is-clicked')) {
            $elem.attr('aria-expanded', 'true');
        } else {
            $elem.attr('aria-expanded', 'false');
        }

        $elem.parent().find('.js-stepped-step').not('.visible-by-default').slideToggle();
    }
}

export default SteppedCta;
